import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
	const gridTestimonials = document.querySelector('#testimonials-slider__sidebar .swiper-wrapper');
	if (gridTestimonials) {
		const gridTestimonialsAmount = gridTestimonials.dataset.totalTestimonials;

		// Testimonials slider
		const testimonialsSwiper = new Swiper('#testimonials-slider__sidebar', {
			modules: [Navigation, Pagination, A11y],
			navigation: {
				nextEl: '.arrow-next-testimonial-sidebar',
				prevEl: '.arrow-prev-testimonial-sidebar',
			},
			// loop: gridResultsAmount > 1,
			a11y: true,
			keyboardControl: true,
			grabCursor: true,
			watchOverflow: true,
			autoHeight: true,
			loop: gridTestimonialsAmount > 1,
		});
	}
};
